import { Building2, FlaskConical, ChevronDown, Check } from 'lucide-react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useAuth } from '../core/auth/AuthContext';

const ENTITY_ICONS: Record<string, typeof Building2> = {
  cabinet: Building2,
  laboratory: FlaskConical,
};

const ENTITY_LABELS: Record<string, string> = {
  cabinet: 'Cabinet',
  laboratory: 'Laboratoire',
  supplier: 'Fournisseur',
  accounting_firm: 'Cabinet comptable',
};

export function EntitySwitcher() {
  const { account, accounts, switchAccount } = useAuth();

  if (accounts.length <= 1) return null;

  const Icon = ENTITY_ICONS[account?.entityType || 'cabinet'] || Building2;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 transition-colors">
        <Icon size={14} />
        <span className="max-w-[120px] truncate">{account?.name}</span>
        <ChevronDown size={12} />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="min-w-[200px] bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 py-1 z-50"
          sideOffset={5}
          align="start"
        >
          <div className="px-3 py-1.5 text-xs text-gray-400 dark:text-gray-500 font-medium">
            Mes entites
          </div>
          {accounts.map(acc => {
            const AccIcon = ENTITY_ICONS[acc.entityType || 'cabinet'] || Building2;
            const isActive = acc.id === account?.id;
            return (
              <DropdownMenu.Item
                key={acc.id}
                className={`flex items-center gap-2 px-3 py-2 text-sm cursor-pointer outline-none transition-colors ${
                  isActive
                    ? 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300'
                    : 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200'
                }`}
                onClick={() => !isActive && switchAccount(acc.id)}
              >
                <AccIcon size={14} />
                <div className="flex-1 min-w-0">
                  <div className="truncate">{acc.name}</div>
                  <div className="text-xs text-gray-400 dark:text-gray-500">
                    {ENTITY_LABELS[acc.entityType || 'cabinet']}
                  </div>
                </div>
                {isActive && <Check size={14} className="text-emerald-600 flex-shrink-0" />}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
